<template>
  <div class="message-container">
    <AlertOctagonOutlineIcon class="icon icon-size-xl" :size="30"/>
    <h3 class="m-0 mt-xxs">Er is momenteel geen e-mailaccount beschikbaar, of je hebt geen toegang tot een bestaand account.</h3>
  </div>
</template>

<script>
export default {
  name: "NoEmailAccountMessageComponent.vue"
}
</script>

<style lang="scss" scoped>
  @import "~@/_default.scss";
  .message-container{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: $spacing-lg;
    padding: $spacing-xl;
  }
  .icon{
    color: $color-primary;
  }
</style>